/**
 * Was der obere Verlauf der Listenspalte abdeckt — 40px, dieselbe Zahl wie
 * `scroll-padding-top` am Scroller (ProjectPage.scss).
 */
export const LIST_TOP_FADE = 40

/**
 * Welche Segmente der Aufgabenliste gerade im Bild stehen — als Abschnitts-ID,
 * `null` für das unsortierte Segment oben. Gemessen beim Klick auf „Neue
 * Aufgabe" der **Listen-Werkzeug-Pille**, nicht laufend (#229).
 *
 * `bottomInset` zieht unten ab, was hinter der Pille liegt, `topInset` oben,
 * was unter dem Verlauf liegt: Dort ist nichts wirklich zu sehen. Ein
 * versteckter Tab misst 0 und liefert nichts.
 */
export function measureVisibleSectionKeys(scroller: HTMLElement, bottomInset: number, topInset = 0): (string | null)[] {
  const frame = scroller.getBoundingClientRect()
  if (frame.height === 0) return []
  const top = frame.top + topInset
  const bottom = frame.bottom - bottomInset
  return [...scroller.querySelectorAll<HTMLElement>('.project-page__segment')]
    .filter(segment => {
      const box = segment.getBoundingClientRect()
      return box.bottom > top && box.top < bottom
    })
    .map(segment => segment.dataset.sectionId ?? null)
}
